<script>
import TwTransitionContainer from '@/components/generic/tw-transition-container.vue'

export default {
  name: 'TwAlert',
  components: { TwTransitionContainer },
  props: {
    message: {
      type: String,
      default: null
    },
    variant: {
      type: String,
      default: 'info'
    }
  },
  emits: ['closed','shown'],
  data() {
    return {
      Show: false
    }
  },
  watch: {
    message() {
      this.Show = true
    },
    Show() {
      if(this.Show) {
        setTimeout(() => {
          this.Show = false
        }, 3000)
      }
    }
  },
  methods: {
    close() {
      this.Show = false
      this.$emit('closed')
    },
    show() {
      this.Show = true
      this.$emit('shown')
    }
  }
}
</script>

<template>
  <tw-transition-container>
    <div v-if="Show" class="rounded-md bg-green-50 p-4">
      <div class="flex">
        <div class="flex-shrink-0">
          <svg class="h-5 w-5 text-green-400" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
            <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.28 7.22a.75.75 0 00-1.06 1.06L8.94 10l-1.72 1.72a.75.75 0 101.06 1.06L10 11.06l1.72 1.72a.75.75 0 101.06-1.06L11.06 10l1.72-1.72a.75.75 0 00-1.06-1.06L10 8.94 8.28 7.22z" clip-rule="evenodd" />
          </svg>
        </div>
        <div class="ml-3">
          <slot>
            <h4 class="text-green-800">
              {{ message }}
            </h4>
          </slot>
        </div>
        <div class="ml-auto pl-3">
          <div class="-mx-1.5 -my-1.5">
            <button type="button" class="inline-flex rounded-md bg-green-50 p-1.5 text-green-400 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50" @click="close">
              <span class="sr-only">Dismiss</span>
              <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </tw-transition-container>
</template>

<style scoped>


</style>
